package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2023_08_25_Day_1
import com.veldekar.components.logs.Log_2023_08_25_Day_2
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2023-08-25")
@Composable
public fun Log_2023_08_25(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Escape to Malus",
        ogTitle = "Escape to Malus",
        date = LocalDate(2_023, 8, 25),
        ogDescription = "After deceiving Sylus, the heroes reach the imperial city of Malus and visit the legendary Traveler’s Doorstep.",
        ogImage = "ai/2023-08-25.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-36", dateString = "Newgrowth 36")
        Log_2023_08_25_Day_1()
        SessionDayHeader(dayId = "newgrowth-37", dateString = "Newgrowth 37")
        Log_2023_08_25_Day_2()
    }
}
